<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>线索渠道列表</h4>
        </div>
        <div class="main-bd mg20">
            <el-row class="searchSection">
                <el-form ref="filterModel" :inline="true" :model="filterModel">
                  <el-form-item label="页面名称" >
                    <el-input size="small" v-model="filterModel.name" placeholder="请输入关键词"></el-input>
                  </el-form-item>
                  <el-form-item label="产品类">
                        <el-select v-model="filterModel.product_id">
                            <el-option label="全部" value="0"></el-option>
                            <el-option v-for="(item, key) in productList" :key="key" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-date-picker
                            size="small"
                            v-model="filterModel.created_at"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="起始日期" prop="start_time">
                            <el-date-picker
                                    size="small"
                                    v-model="filterModel.start_time"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="选择起始日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="截止日期" prop="end_time">
                            <el-date-picker
                                    size="small"
                                    v-model="filterModel.end_time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择截止日期">
                            </el-date-picker>
                        </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                        <el-button @click="resetForm()" size="small">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row class="addBtn">
                <el-button v-if="Acs('/sales-leads-channel/create')" type="primary" size="small" @click="handleAdd">+ 新增渠道</el-button>
            </el-row>
            <el-table size="mini" style="width:100%" class="tabTopBorder" v-loading="loading" :data="channelList">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="name" label="页面名称"></el-table-column>
                <el-table-column prop="product_name" label="所属产品" width="100"></el-table-column>
                <el-table-column prop="parent_name" label="一级渠道"></el-table-column>
                <el-table-column label="渠道url" width="500">
                    <template slot-scope="scope">
                        <span v-if="scope.row.url">{{scope.row.url.includes('?') ? scope.row.url + '&' : scope.row.url + '?'}}source={{scope.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="创建时间"></el-table-column>
                <el-table-column prop="user_name" label="创建人"></el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column label="操作"> . '?source=' . $this->id
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleEdit(scope.row, false)">查看</el-button>
                        <el-button v-if="Acs('/sales-leads-channel/update')" type="text" size="small" @click="handleEdit(scope.row, true)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>

        <!-- 查看编辑 -->
        <el-dialog title="渠道配置" :visible.sync="dialogChannelView" @close="viewDialogClose()" width="35%" center>
            <el-form :model="edit_form" :rules="rules" ref="view_form" :label-width="formLabelWidth">
                <el-form-item label="二级渠道名称" prop="name">
                    <el-input v-model="edit_form.name" autocomplete="off" :disabled="!is_edit"></el-input>
                </el-form-item>
                <el-form-item label="所属一级渠道" prop="pid">
                    <el-select v-model="edit_form.pid" placeholder="请选择" :disabled="!is_edit">
                        <el-option v-for="(item, key) in parentList" :key="key" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产品" prop="product_id">
                    <el-select v-model="edit_form.product_id" placeholder="请选择" :disabled="!is_edit">
                        <el-option v-for="(item, key) in productList" :key="key" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序号" prop="sort">
                    <el-input type="number" v-model="edit_form.sort" autocomplete="off" :disabled="!is_edit" style="width:100px;"></el-input>
                    &nbsp;&nbsp;&nbsp;数字越大，排序越靠前，相同数字，按创建时间升序排列
                </el-form-item>
                <el-form-item label="申请地址" prop="url">
                    <el-input v-model="edit_form.url" autocomplete="off" :disabled="!is_edit"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="edit_form.remark" autocomplete="off" :disabled="!is_edit"></el-input>
                </el-form-item>
            </el-form>
            <div v-if="is_edit" slot="footer" class="dialog-footer">
                <el-button @click="dialogChannelView = false">取 消</el-button>
                <el-button type="primary" @click="dialogChannelViewSubmit()" :loading="isDisable">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import SaleChannelService from "~/services/SaleChannel";
    import ProductService from "~/services/product";
    export default {
        data() {
            return {
                filterModel: {
                    name: '',
                    product_id: '0',
                    // start_time: '',
                    // end_time: '',
                    created_at: []
                },
                edit_form: {
                    id: '',
                    name: '',
                    pid: '',
                    product_id: '',
                    url: '',
                    remark: '',
                    sort: 0,
                },
                is_edit: true,
                loading: true,
                channelList: [],     //渠道列表
                productList: [],     //产品列表
                parentList: [],     //一级渠道列表
                linkPage: null,       //分页信息
                dialogChannelView: false, // 显示查看编辑窗口
                formLabelWidth: '130px',
                isDisable:false,
                rules: {
                    name: [
                        {
                            required: true,
                            message: "请输入渠道名校",
                            trigger: "blur"
                        },
                        {
                            min: 2,
                            max: 50,
                            message: "长度在 2 到 50 个字符",
                            trigger: "blur"
                        }
                    ],
                    pid: [
                        {
                            required: true,
                            message: "请选择一级渠道",
                            trigger: "change"
                        },
                    ],
                    // product_id: [
                    //     {
                    //         required: true,
                    //         message: "请选择所属产品",
                    //         trigger: "change"
                    //     },
                    // ],
                    url: [
                    {
                            min: 2,
                            max: 200,
                            message: "申请地址长度在 2 到 200 个字符",
                            trigger: "blur"
                        }
                    ],
                    remark: [
                    {
                            min: 2,
                            max: 200,
                            message: "备注长度在 2 到 200 个字符",
                            trigger: "blur"
                        }
                    ],
                    sort: [
                        {
                            type: 'number',
                            validator: (rule, value, callback) => {
                                if (value === '' || value === undefined || value === null) {
                                    callback(new Error('请输入排序号'));
                                } else if (value < 0 || value > 100000) {
                                    callback(new Error('排序规则必须在0到100000之间'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: "blur"
                        }
                    ]
                },
            }
        },
        components: {
            Pagination,
        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            let params = this.filterModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.getList(params);
        },
        created() {
            this.getList(this.filterModel);
            this.getProductList();
            this.getParentList();
        },
        methods: {
            // 获取销售渠道列表
            getList(params = {}) {
                this.loading = true;
                SaleChannelService.getList(params).then(res => {
                    if (res.code == 0) {
                        this.channelList = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                    this.loading = false;
                })
            },

            // 获取产品列表
            getProductList() {
                this.loading = true;
                ProductService.getOptionList().then(res => {
                    if (res.code == 0) {
                        this.productList = res.data;
                    }
                    this.loading = false;
                })
            },

            // 获取一级渠道列表
            getParentList() {
                this.loading = true;
                SaleChannelService.getParentList().then(res => {
                    if (res.code == 0) {
                        this.parentList = res.data;
                    }
                    this.loading = false;
                })
            },

            clearEditForm() {
                this.edit_form = _.clone(_.extend(this.edit_form, {
                    id: '',
                    name: '',
                    pid: '',
                    product_id: '',
                    url: '',
                    remark: '',
                    sort: 0,
                }));
            },

            viewDialogClose() {
                this.$refs.view_form.clearValidate();
                this.dialogChannelView = false;
            },

            // 添加
            handleAdd() {
                this.clearEditForm();
                this.is_edit = true;
                this.dialogChannelView = true;
            },
            // 查看、编辑
            handleEdit(channel, is_edit) {
                this.clearEditForm();
                this.edit_form.id = channel.id;
                this.edit_form.name = channel.name;
                this.edit_form.pid = channel.pid ? channel.pid : '';
                this.edit_form.product_id = channel.product_id ? channel.product_id.toString() : '';
                this.edit_form.url = channel.url;
                this.edit_form.remark = channel.remark;
                this.edit_form.sort = channel.sort;
                this.dialogChannelView = true;
                this.is_edit = is_edit;
            },
            
            resetForm() {
                this.filterModel = _.clone(_.extend(this.filterModel, {
                    // start_time: '',
                    // end_time: '',
                    created_at: [],
                    name: '',
                    product_id: '0',
                }));
                this.getList();
            },

            //筛选查询
            submitSearch() {
                let params = {
                    name: this.filterModel.name,
                    // start_time: this.filterModel.start_time,
                    // end_time: this.filterModel.end_time,
                    product_id: this.filterModel.product_id,
                    created_at: this.filterModel.created_at,
                }
                _.each(params, (val, key) => {
                    if (!val) delete params[key];
                })
                this.getList(params);
            },

            dialogChannelViewSubmit(){
                this.$refs['view_form'].validate(valid => {
                    this.isDisable = true;
                    let params = {
                        id: this.edit_form.id,
                        name: this.edit_form.name,
                        pid: this.edit_form.pid,
                        product_id: this.edit_form.product_id,
                        url: this.edit_form.url,
                        remark: this.edit_form.remark,
                        sort: this.edit_form.sort,
                    }
                    _.each(params, (val, key) => {
                        if (!val) delete params[key];
                    })
                    if (valid) {
                        if(params.id > 0){
                            SaleChannelService.edit(params).then(res => {
                                this.isDisable = false;
                                if(res.code == 0) {
                                    this.$message({
                                        message:'编辑成功',
                                        type:'success'
                                    });
                                    this.getList();
                                    this.viewDialogClose();
                                }
                                
                            });
                        }else{
                            SaleChannelService.create(params).then(res => {
                                this.isDisable = false;
                                if(res.code == 0) {
                                    this.$message({
                                        message:'添加成功',
                                        type:'success'
                                    });
                                    this.getList();
                                    this.viewDialogClose();
                                }
                            });
                        }
                    } else {
                        this.isDisable = false;
                        return false;
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/clue/channel.vue